import React from "react";
import MDEditor from "@uiw/react-md-editor";

type Props = {
  value: string | undefined
  setValue: React.Dispatch<React.SetStateAction<string | undefined>>
}

function MarkdownEditor({value, setValue}: Props) {
  return (
        <MDEditor value={value} onChange={setValue}/>
  );
}

export default MarkdownEditor;